import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';
import type { ToastProps } from './Totast.types';

import styles from './Toast.module.css';

export const Toast: FC<ToastProps> = ({ message, error, success, duration = 5000, onDismiss }) => {
    const [showToast, setShowToast] = useState(false);


    useEffect(() => {
        if (showToast) {
            setShowToast(true);
            const timeoutId = setTimeout(() => {
                setShowToast(false);

                if (typeof onDismiss === 'function') {
                    onDismiss();
                }
            }, duration);

            return () => clearTimeout(timeoutId);
        }
    }, [duration, onDismiss, showToast]);

    useEffect(() => {
        if (message && message?.length > 0) {
            setShowToast(true);
        }
    }, [message])

    return (
        <>
            <div className={classNames({
                [styles.toast]: true,
                [styles.toastShow]: showToast,
                [styles.toastError]: error,
                [styles.toastSuccess]: success,
            })}>
                <p>
                    {message}
                </p>
            </div>
        </>
    )
}